// src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import CreateTemplatePage from './pages/CreateTemplatePage';
import ManageTemplatesPage from './pages/ManageTemplatesPage';
import { CircularProgress } from '@mui/material';
import { auth } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';

const App = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={user ? <HomePage /> : <LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/create-template" element={user ? <CreateTemplatePage /> : <LoginPage />} />
        <Route path="/manage-templates" element={user ? <ManageTemplatesPage /> : <LoginPage />} />
      </Routes>
    </Router>
  );
};

export default App;
